import Vue from 'vue'
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import App from './App.vue'
import vuetify from './plugins/vuetify';
import StoreData from './store';
import { routes } from './route';
import Api from './apis/Api.js';

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(Vuex);

const store = new Vuex.Store(StoreData);


const router = new VueRouter({
  routes,
  mode: 'history'
});

function isLoggedIn() {
  return localStorage.getItem("token");
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn()) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      console.log(store.state.user);
      if (store.state.user.id)
      {
        next();
      }else{
        Api().get('/user').then(() => {
          next()
        }).catch(() => {
          localStorage.removeItem("token");
          next({
            path: '/',
            query: { redirect: to.fullPath }
          })
        });
      }
    }
  } else if (to.matched.some(record => record.meta.guestOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (isLoggedIn()) {
      next({
        path: '/home',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
